import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, of } from 'rxjs';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { DeepgramGate } from './../../../../../backend/src/core/deepgram/deepgram.gate';
import { LambdaService } from './../../shared/core/lambda.service';
import { WorkspaceHolderService } from './../workspace/workspace.holder.service';

@Injectable({
  providedIn: 'root',
})
export class DeepgramService {
  private sessionIdAndApiKey = new Map<string, string>();

  constructor(
    private lambdaService: LambdaService,
    private workspaceHolderService: WorkspaceHolderService,
    private http: HttpClient
  ) {}

  getTempApiKeyForSession$(sessionId: string) {
    if (this.sessionIdAndApiKey.has(sessionId)) {
      return of(this.sessionIdAndApiKey.get(sessionId));
    }

    return this.lambdaService
      .run$(ResourceName.deepgram, DeepgramGate.actions.getTempApiKeyForSession, {
        sessionId,
      })
      .pipe(
        map((result) => {
          this.sessionIdAndApiKey.set(sessionId, result);
          return result;
        })
      );
  }

  /**
   *
   * aura-angus-en    [Irish, male]
   * aura-arcas-en    [American, male]
   * aura-asteria-en  [American, female]
   * aura-athena-en   [British, female]
   * aura-helios-en   [British, male]
   * aura-hera-en     [American, female]
   * aura-luna-en     [American, female]
   * aura-orion-en    [American, male]
   * aura-orpheus-en  [American, male]
   * aura-perseus-en  [American, male]
   * aura-stella-en   [American, female]
   * aura-zeus-en     [American, male]
   *
   */
  textToSpeech$(
    sessionId: string,
    input: string,
    config?: {
      voice?: string;
    }
  ) {
    const request = {
      workspaceId: this.workspaceHolderService.currentWorkspace().id,
      sessionId,
      input,
      voice: config?.voice ?? 'aura-zeus-en',
    };

    return this.http.post<any>(`https://voice-server-staging.peakmojo.ai/buyer-voice`, request).pipe(
      map((data) => {
        return data.url;
      })
    );
  }
}
